var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fs-3" },
    [
      _c(
        "el-dropdown",
        { staticClass: "absolute top-right-3" },
        [
          _c("i", { staticClass: "icon-burger p-2" }),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            _vm._l(_vm.data.actions, function(action, index) {
              return _c(
                "el-dropdown-item",
                {
                  key: index,
                  class: !_vm.hasAccess(action.permission, _vm.permissions)
                    ? "link-disabled"
                    : "",
                  attrs: {
                    disabled: !_vm.hasAccess(action.permission, _vm.permissions)
                  }
                },
                [
                  action.type == "vuejs"
                    ? _c(
                        "a",
                        {
                          class: !_vm.hasAccess(
                            action.permission,
                            _vm.permissions
                          )
                            ? "link-disabled"
                            : "",
                          on: {
                            click: function($event) {
                              !_vm.hasAccess(action.permission, _vm.permissions)
                                ? null
                                : _vm.emitCall(
                                    action.value,
                                    _vm.data,
                                    !_vm.hasAccess(
                                      action.permission,
                                      _vm.permissions
                                    )
                                  )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(action.label) +
                              "\n                "
                          )
                        ]
                      )
                    : _c(
                        "a",
                        {
                          class: !_vm.hasAccess(
                            action.permission,
                            _vm.permissions
                          )
                            ? "link-disabled"
                            : "",
                          attrs: {
                            href: !_vm.hasAccess(
                              action.permission,
                              _vm.permissions
                            )
                              ? null
                              : action.value
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(action.label) +
                              "\n                "
                          )
                        ]
                      )
                ]
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "mt-0" }, [_vm._v(_vm._s(_vm.data.name))]),
      _vm._v(" "),
      _c("ul", { staticClass: "m-0" }, [
        _c("li", { staticClass: "mb-1" }, [_vm._v(_vm._s(_vm.data.part1))]),
        _vm._v(" "),
        _vm.data.part2 != ""
          ? _c("li", { staticClass: "mb-1" }, [_vm._v(_vm._s(_vm.data.part2))])
          : _vm._e(),
        _vm._v(" "),
        _vm.data.part2 != ""
          ? _c("li", { staticClass: "mb-1" }, [_vm._v(_vm._s(_vm.data.part3))])
          : _vm._e(),
        _vm._v(" "),
        _vm.data.part2 != ""
          ? _c("li", { staticClass: "mb-1" }, [_vm._v(_vm._s(_vm.data.part4))])
          : _vm._e(),
        _vm._v(" "),
        _c("li", { staticClass: "mb-1" }, [
          _vm._v(_vm._s(_vm.data.zip) + " " + _vm._s(_vm.data.town))
        ]),
        _vm._v(" "),
        _c("li", [_vm._v(_vm._s(_vm.data.country))])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }